import { Tooltip } from '@material-ui/core';
import React from 'react';
import { clsx } from 'helpers/utils/HTMLUtils';
import style from './nucleoButton.scss';
const { rootClassName } = style;

export interface NucleoButtonProps {
  value: boolean;
  onChange: (newValue: boolean) => void;
  disabled?: boolean;
  label: string | React.ReactNode;
  tooltipLabel?: string;
}

export default function NucleoButton(props: NucleoButtonProps) {
  return (
    <Tooltip arrow title={props.tooltipLabel || ''}>
      <button
        className={clsx([rootClassName, props.value ? 'green' : 'white'])}
        onClick={() => {
          props.onChange(!props.value);
        }}
        disabled={props.disabled}
      >
        {props.label}
      </button>
    </Tooltip>
  );
}
